export class FRAES {
  public static readonly STRUCTURE = {
    EXTERNAL_DIAMETER_KEY: 'Diâmetro Externo',
    INTERNAL_DIAMETER_KEY: 'Diâmetro Interno',
    DRY_WEIGHT_KEY: 'Peso no ar duto vazio',
    WET_WEIGHT_KEY: 'Peso no mar duto vazio',
    AXIAL_STIFFENESS_KEY: 'Rigidez axial duto tracionado',
    TORSIONAL_STIFFENESS_KEY: 'Rigidez a torção (menor valor)',
    BENDING_STIFFENESS_KEY: 'Rigidez a flexão',
  };
}
